import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "multi-select-filter" }
const _hoisted_2 = {
  key: 0,
  class: "token-input form-control d-flex align-items-center",
  "data-bs-toggle": "dropdown"
}
const _hoisted_3 = { class: "chips d-flex flex-wrap align-items-center" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "label-content selected-user-name" }
const _hoisted_6 = {
  key: 0,
  class: "chip selected-user-name"
}
const _hoisted_7 = ["placeholder", "focus"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1 /* HOISTED */)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "message-container" }
const _hoisted_11 = {
  class: "dropdown-menu p-0",
  ref: "dropdownElement"
}
const _hoisted_12 = { class: "input-group p-1" }
const _hoisted_13 = ["placeholder", "focus"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
  ])
], -1 /* HOISTED */)
const _hoisted_15 = { class: "form-check ps-0" }
const _hoisted_16 = ["id", "value"]
const _hoisted_17 = ["for"]
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 0,
  class: "text-muted ps-3 pt-1"
}
const _hoisted_21 = { class: "form-check ps-0" }
const _hoisted_22 = ["id", "value"]
const _hoisted_23 = ["for"]
const _hoisted_24 = ["title"]
const _hoisted_25 = ["title"]
const _hoisted_26 = {
  key: 1,
  class: "text-muted ps-3 pt-1"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* HOISTED */)
const _hoisted_28 = {
  key: 0,
  class: "ps-2 text-capitalize"
}
const _hoisted_29 = { class: "form-check pe-0" }
const _hoisted_30 = ["id", "value"]
const _hoisted_31 = ["for"]
const _hoisted_32 = ["title"]
const _hoisted_33 = ["title"]
const _hoisted_34 = {
  key: 2,
  class: "content content-y h-100"
}
const _hoisted_35 = { class: "form-check ps-0" }
const _hoisted_36 = ["id", "value"]
const _hoisted_37 = ["for"]
const _hoisted_38 = ["title"]
const _hoisted_39 = {
  key: 0,
  class: "text-muted ps-3 pt-1"
}
const _hoisted_40 = { class: "form-check ps-0" }
const _hoisted_41 = ["id", "value"]
const _hoisted_42 = ["for"]
const _hoisted_43 = ["title"]
const _hoisted_44 = {
  key: 1,
  class: "text-muted ps-3 pt-1"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* HOISTED */)
const _hoisted_46 = {
  key: 0,
  class: "ps-2 text-capitalize"
}
const _hoisted_47 = { class: "form-check ps-0" }
const _hoisted_48 = ["id", "value"]
const _hoisted_49 = ["for"]
const _hoisted_50 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPill = _resolveComponent("ProductPill")!
  const _component_ScrollPagination = _resolveComponent("ScrollPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`dropdown ${_ctx.isCalendar ? 'calendar-dropdown' : ''}`),
      ref: "dropdown"
    }, [
      (_ctx.isCalendar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSelectedEmployees, (user) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chip",
                  key: `${user.name}-${user.value}`
                }, [
                  _createElementVNode("span", {
                    class: "d-flex align-items-center cursor-pointer",
                    onClick: (e) => _ctx.removeUser(e, user)
                  }, "x", 8 /* PROPS */, _hoisted_4),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(user.name), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (_ctx.selectedItems.length > 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "+" + _toDisplayString(_ctx.selectedItems.length - 3) + " more", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "search-input",
                placeholder: _ctx.placeholder,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.calendarSearch) = $event)),
                focus: _ctx.open
              }, null, 8 /* PROPS */, _hoisted_7), [
                [_vModelText, _ctx.calendarSearch]
              ])
            ]),
            _hoisted_8
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(`btn border bg-white dropdown-toggle px-2 ${_ctx.disabled ? 'disabled' : ''} ${_ctx.classes} `),
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
            disabled: _ctx.disabled
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.message), 1 /* TEXT */)
          ], 10 /* CLASS, PROPS */, _hoisted_9)),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        (!_ctx.isCalendar)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: _ctx.getInputPlaceholder,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                  onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCredentialsFetch && _ctx.onCredentialsFetch(...args))),
                  focus: _ctx.open
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13), [
                  [_vModelText, _ctx.search]
                ]),
                _hoisted_14
              ])
            ], 32 /* HYDRATE_EVENTS */))
          : _createCommentVNode("v-if", true),
        (_ctx.isCalendar)
          ? (_openBlock(), _createBlock(_component_ScrollPagination, {
              key: 1,
              "page-number": _ctx.pageNumber,
              onPageNumberUpdate: _ctx.pageNumberUpdated
            }, {
              default: _withCtx(() => [
                _createElementVNode("section", {
                  class: _normalizeClass(["content content-y h-100 d-flex flex-column overflow-auto flex-nowrap w-100 h-100 scroll-paginate", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
                }, [
                  (_ctx.getIsSearching)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueFetchedItems, (item, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "dropdown-item ps-3",
                            key: item.value
                          }, [
                            _createElementVNode("div", _hoisted_15, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "me-2",
                                id: `${_ctx.name}fetched${item.value}${index}`,
                                value: item,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedOptions) = $event)),
                                onChange: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSelectedItems && _ctx.updateSelectedItems(...args)), ["prevent"]))
                              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16), [
                                [_vModelCheckbox, _ctx.selectedOptions]
                              ]),
                              _createElementVNode("label", {
                                class: "form-check-label",
                                for: `${_ctx.name}fetched${item.value}${index}`
                              }, [
                                (_ctx.isMap)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "label-content",
                                      title: `${item.name.split('+')[0]}`
                                    }, [
                                      _createTextVNode(_toDisplayString(item.name.split("+")[0]) + " ", 1 /* TEXT */),
                                      _createVNode(_component_ProductPill, {
                                        productId: item.application
                                      }, null, 8 /* PROPS */, ["productId"])
                                    ], 8 /* PROPS */, _hoisted_18))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "label-content",
                                      title: `${item.name}`
                                    }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_19))
                              ], 8 /* PROPS */, _hoisted_17)
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */)),
                        (!_ctx.fetchedItems || _ctx.fetchedItems.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, " No matches found "))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.getIsSearching)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("a", {
                          class: "clear-link pt-2 ps-2",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSelection()))
                        }, " Clear selected items "),
                        (_ctx.selectedItems)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.displayItems, (item, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "dropdown-item ps-3",
                                key: item.value
                              }, [
                                _createElementVNode("div", _hoisted_21, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "me-2",
                                    id: `${_ctx.name}display${item.value}${index}`,
                                    value: item,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedOptions) = $event)),
                                    onChange: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSelectedItems && _ctx.updateSelectedItems(...args)), ["prevent"]))
                                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22), [
                                    [_vModelCheckbox, _ctx.selectedOptions]
                                  ]),
                                  _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: `${_ctx.name}display${item.value}${index}`
                                  }, [
                                    (_ctx.isMap)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "label-content",
                                          title: `${item.name.split('+')[0]}`
                                        }, [
                                          _createTextVNode(_toDisplayString(item.name.split("+")[0]) + " ", 1 /* TEXT */),
                                          _createVNode(_component_ProductPill, {
                                            productId: item.application
                                          }, null, 8 /* PROPS */, ["productId"])
                                        ], 8 /* PROPS */, _hoisted_24))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: "label-content",
                                          title: `${item.name}`
                                        }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_25))
                                  ], 8 /* PROPS */, _hoisted_23)
                                ])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (!_ctx.displayItems || _ctx.displayItems.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Nothing selected "))
                          : _createCommentVNode("v-if", true),
                        (_ctx.suggestedItems && _ctx.suggestedItems.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _hoisted_27,
                              (_ctx.name)
                                ? (_openBlock(), _createElementBlock("h6", _hoisted_28, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.name), 1 /* TEXT */)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueSuggestedItems, (item, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "dropdown-item p-0",
                                  key: item.value
                                }, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "me-2",
                                      id: `${_ctx.name}suggested${item.value}${index}`,
                                      value: item,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedOptions) = $event)),
                                      onChange: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSelectedItems && _ctx.updateSelectedItems(...args)), ["prevent"]))
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_30), [
                                      [_vModelCheckbox, _ctx.selectedOptions]
                                    ]),
                                    _createElementVNode("label", {
                                      class: "form-check-label",
                                      for: `${_ctx.name}suggested${item.value}${index}`
                                    }, [
                                      (_ctx.isMap)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "label-content",
                                            title: `${item.name.split('+')[0]}`
                                          }, [
                                            _createTextVNode(_toDisplayString(item.name.split("+")[0]) + " ", 1 /* TEXT */),
                                            _createVNode(_component_ProductPill, {
                                              productId: item.application
                                            }, null, 8 /* PROPS */, ["productId"])
                                          ], 8 /* PROPS */, _hoisted_32))
                                        : (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: "label-content",
                                            title: `${item.name}`
                                          }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_33))
                                    ], 8 /* PROPS */, _hoisted_31)
                                  ])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["page-number", "onPageNumberUpdate"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
              (_ctx.getIsSearching)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueFetchedItems, (item, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "dropdown-item ps-3",
                        key: item.value
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "me-2",
                            id: `${_ctx.name}fetched${item.value}${index}`,
                            value: item,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedOptions) = $event)),
                            onChange: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSelectedItems && _ctx.updateSelectedItems(...args)), ["prevent"]))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_36), [
                            [_vModelCheckbox, _ctx.selectedOptions]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: `${_ctx.name}fetched${item.value}${index}`
                          }, [
                            _createElementVNode("span", {
                              class: "label-content",
                              title: `${item.name}`
                            }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_38)
                          ], 8 /* PROPS */, _hoisted_37)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (!_ctx.fetchedItems || _ctx.fetchedItems.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, " No matches found "))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!_ctx.getIsSearching)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("a", {
                      class: "clear-link pt-2 ps-2",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toggleSelection()))
                    }, " Clear selected items "),
                    (_ctx.selectedItems)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.displayItems, (item, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "dropdown-item ps-3",
                            key: item.value
                          }, [
                            _createElementVNode("div", _hoisted_40, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "me-2",
                                id: `${_ctx.name}display${item.value}${index}`,
                                value: item,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedOptions) = $event)),
                                onChange: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSelectedItems && _ctx.updateSelectedItems(...args)), ["prevent"]))
                              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_41), [
                                [_vModelCheckbox, _ctx.selectedOptions]
                              ]),
                              _createElementVNode("label", {
                                class: "form-check-label",
                                for: `${_ctx.name}display${item.value}${index}`
                              }, [
                                _createElementVNode("span", {
                                  class: "label-content",
                                  title: `${item.name}`
                                }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_43)
                              ], 8 /* PROPS */, _hoisted_42)
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (!_ctx.displayItems || _ctx.displayItems.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Nothing selected "))
                      : _createCommentVNode("v-if", true),
                    (_ctx.suggestedItems && _ctx.suggestedItems.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _hoisted_45,
                          (_ctx.name)
                            ? (_openBlock(), _createElementBlock("h6", _hoisted_46, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.name), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueSuggestedItems, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "dropdown-item ps-3",
                              key: item.value
                            }, [
                              _createElementVNode("div", _hoisted_47, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: "me-2",
                                  id: `${_ctx.name}suggested${item.value}${index}`,
                                  value: item,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedOptions) = $event)),
                                  onChange: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSelectedItems && _ctx.updateSelectedItems(...args)), ["prevent"]))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_48), [
                                  [_vModelCheckbox, _ctx.selectedOptions]
                                ]),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: `${_ctx.name}suggested${item.value}${index}`
                                }, [
                                  _createElementVNode("span", {
                                    class: "label-content",
                                    title: `${item.name}`
                                  }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_50)
                                ], 8 /* PROPS */, _hoisted_49)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]))
      ], 512 /* NEED_PATCH */), [
        [_vShow, !_ctx.disabled]
      ])
    ], 2 /* CLASS */)
  ]))
}